import { useQuery } from "@tanstack/react-query";
import type {
  LeadManagerFetchInterface,
  LeadManagerHelloResponse
} from "@dealer-center/ddc-pages-lead-manager-interface";

const LAMBDA_BASE = "/landing/nxlambda/leadManager";

export function useLeadManagerAPIInterface({
  searchValue
}: LeadManagerFetchInterface) {
  return useQuery({
    queryKey: ["ddc-pages-lead-manager", { searchValue }],
    queryFn: () =>
      fetchLeadManager(encodeURIComponent(searchValue?.trim() || "")),
    enabled: !!searchValue && searchValue.trim().length > 0,
    retry: 1,
    staleTime: 1000 * 60 * 5
  });
}

export function useLeadManagerHello(isEnabled: boolean) {
  return useQuery({
    queryKey: ["ddc-pages-lead-manager-hello"],
    queryFn: fetchHello,
    enabled: isEnabled,
    retry: 1,
    staleTime: 0
  });
}

const fetchLeadManager = async (
  searchValue: string
): Promise<LeadManagerHelloResponse> => {
  const res = await fetch(`${LAMBDA_BASE}/${searchValue}`);
  if (res.ok) return res.json();
  throw new Error(res.statusText);
};

const fetchHello = async (): Promise<LeadManagerHelloResponse> => {
  const res = await fetch(`${LAMBDA_BASE}/test`);
  if (res.ok) return res.json();
  throw new Error(res.statusText);
};
